import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  successEmails: [],
  failedEmails: [],
  totalInvites: 5,
  isInvitationActive: false,
};

const InvitationSlice = createSlice({
  name: "invitationListEmails",
  initialState: initialState,
  reducers: {
    setEnteredSuccessEmails: (state, action) => {
      state.successEmails = action.payload;
    },
    setEnteredFailedEmails: (state, action) => {
      state.failedEmails = action.payload;
    },
    removeFailedEmails: (state, action) => {
      const { emailId } = action.payload;
      state.failedEmails = state.failedEmails.filter((email) => email._id !== emailId);
    },
    
    clearEmails: (state) => {
      state.successEmails = [];
      state.failedEmails = [];
      state.totalInvites = 5;
    },
    setTotalInvites: (state, action) => {
      state.totalInvites = action.payload;
    },
    setIsInvitationActive: (state, action) => {
      state.isInvitationActive = action.payload;
    },
  },
});
export const {
  setEnteredSuccessEmails,
  setEnteredFailedEmails,
  clearEmails,
  setTotalInvites,
  removeFailedEmails,
  setIsInvitationActive,
} = InvitationSlice.actions;
export default InvitationSlice.reducer;